import { Stack } from '@mui/material'
import { useTranslation } from 'next-i18next'
import { getEventTypeStyle } from 'components/Hook/useEventCard'
import { raceCategoriesLevel1 } from 'helpers/raceCategoryLevels'
import { Type } from './RaceCard.style'

interface EventTypeProps {
  type: string
  distance?: string | null
}

export const EventType = ({ type, distance }: EventTypeProps) => {
  const eventType = type
    ? getEventTypeStyle(type as keyof typeof raceCategoriesLevel1)
    : null

  const { t } = useTranslation(['common', 'event'])
  return eventType ? (
    <Stack direction="row" gap={1}>
      <Type
        $color={eventType.color}
        $backgroundColor={eventType.backgroundColor}
      >
        {t(eventType.value)}
      </Type>
      {distance && (
        <Type $color="onBlue" $backgroundColor="blue">
          {t(distance as never)}
        </Type>
      )}
    </Stack>
  ) : null
}
